export enum ErrorType {
  UnAuthenticated = "UNAUTHENTICATED",
  UpdateUserFailedRoles = "UPDATE_USER_FAILED_ROLES",
  CreateZoomUrlFailed = "CREATE_ZOOM_URL_FAILED",
  DuplicateExpertAlias = "DUPLICATE_EXPERT_ALIAS",
  DuplicateFieldAlias = "DUPLICATE_FIELD_ALIAS",
  DuplicateVideoLessonAlias = "DUPLICATE_VIDEO_LESSON_ALIAS",
}
